// ** Type Imports
import { PaletteMode } from '@mui/material'
import { ThemeColor } from 'src/@core/layouts/types'

const DefaultPalette = (mode: PaletteMode, themeColor: ThemeColor) => {
  // ** Vars
  const lightColor = '58, 53, 65'
  const newLightColor = '0, 0, 0'
  const darkColor = '231, 227, 252'
  const secondaryColor = '165, 165, 165'
  const additionalColor = '26, 40, 63'
  const mainColor = mode === 'light' ? newLightColor : darkColor

  const primaryGradient = () => {
    if (themeColor === 'primary') {
      return '#90BDFF'
    } else if (themeColor === 'secondary') {
      return '#90BDFF'
    } else if (themeColor === 'success') {
      return '#90BDFF'
    } else if (themeColor === 'error') {
      return '#90BDFF'
    } else if (themeColor === 'warning') {
      return '#90BDFF'
    } else {
      return '#90BDFF'
    }
  }

  return {
    customColors: {
      main: mainColor,
      primaryGradient: primaryGradient(),
      tableHeaderBg: mode === 'light' ? '#F9FAFC' : '#3D3759',
      black: `rgb(${mainColor})`,
      mainGreen: `rgba(30, 52, 42, 0.8)`,
    },
    common: {
      black: '#000',
      white: '#FFF',
    },
    mode: mode,
    primary: {
      light: '#90BDFF',
      main: '#90BDFF',
      dark: '#90BDFF',
      contrastText: '#000',
    },
    secondary: {
      light: '#90BDFF',
      main: '#90BDFF',
      dark: '#90BDFF',
      contrastText: '#FFF',
    },
    success: {
      light: '#90BDFF',
      main: '#90BDFF',
      dark: '#90BDFF',
      contrastText: '#FFF',
    },
    error: {
      light: '#90BDFF',
      main: '#90BDFF',
      dark: '#90BDFF',
      contrastText: '#FFF',
    },
    warning: {
      light: '#FFCA64',
      main: '#FFB400',
      dark: '#E09E00',
      contrastText: '#FFF',
    },
    info: {
      light: '#32BAFF',
      main: '#16B1FF',
      dark: '#139CE0',
      contrastText: '#FFF',
    },
    grey: {
      50: '#FAFAFA',
      100: '#F5F5F5',
      200: '#EEEEEE',
      300: '#E0E0E0',
      400: '#BDBDBD',
      500: '#9E9E9E',
      600: '#757575',
      700: '#616161',
      800: '#424242',
      900: '#212121',
      A100: '#D5D5D5',
      A200: '#AAAAAA',
      A400: '#616161',
      A700: '#303030',
    },
    text: {
      primary: `rgba(${mainColor}, 0.8)`,
      secondary: `rgb(${secondaryColor})`,
      disabled: `rgba(${mainColor}, 0.38)`,
      additional: `rgba(${additionalColor}, 0.87)`,
    },
    divider: `rgba(${mainColor}, 0.12)`,
    background: {
      paper: mode === 'light' ? '#FFF' : '#312D4B',
      default: mode === 'light' ? '#F5FAFA' : '#28243D',
    },
    action: {
      active: `rgba(${mainColor}, 0.54)`,
      hover: `rgba(${mainColor}, 0.04)`,
      selected: `rgba(${mainColor}, 0.08)`,
      disabled: `rgba(${mainColor}, 0.3)`,
      disabledBackground: `rgba(${mainColor}, 0.18)`,
      focus: `rgba(${mainColor}, 0.12)`,
    },
  }
}

export default DefaultPalette
